import * as React from 'react'
import Lottie from 'react-lottie'
import * as dasherExcitedAnimation from './DasherExcitedAnimation.json'

type DasherExcitedProps = {
  height?: number
  width?: number
  animationDelayMs?: number
}

const DEFAULT_ANIMATION_START_DELAY_MS = 750

export const DasherExcited: React.FC<DasherExcitedProps> = ({
  width = 343,
  height = 208,
  animationDelayMs = DEFAULT_ANIMATION_START_DELAY_MS,
}) => {
  // Used to have a delay before the animation starts
  const [isStopped, setIsStopped] = React.useState<boolean>(true)
  React.useEffect(() => {
    setTimeout(() => {
      setIsStopped(false)
    }, animationDelayMs)
  }, [animationDelayMs])

  return (
    <Lottie
      options={{
        autoplay: false,
        loop: false,
        animationData: dasherExcitedAnimation,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      }}
      height={height}
      width={width}
      isStopped={isStopped}
    />
  )
}
